export const normalizeHexInput = value => {
  const raw = String(value == null ? '' : value).trim();
  if (!raw) return '';
  const withHash = raw.charAt(0) === '#' ? raw : `#${raw}`;
  if (/^#[0-9a-fA-F]{6}$/.test(withHash)) return withHash.toUpperCase();
  if (/^#[0-9a-fA-F]{3}$/.test(withHash)) {
    return (
      '#' +
      withHash.charAt(1) +
      withHash.charAt(1) +
      withHash.charAt(2) +
      withHash.charAt(2) +
      withHash.charAt(3) +
      withHash.charAt(3)
    ).toUpperCase();
  }
  return '';
};

const getRelativeLuminanceFromHex = hex => {
  const normalized = normalizeHexInput(hex);
  if (!normalized) return 0;
  const r = parseInt(normalized.slice(1, 3), 16);
  const g = parseInt(normalized.slice(3, 5), 16);
  const b = parseInt(normalized.slice(5, 7), 16);
  const linearize = channel => {
    const value = channel / 255;
    return value <= 0.03928 ? value / 12.92 : Math.pow((value + 0.055) / 1.055, 2.4);
  };
  return 0.2126 * linearize(r) + 0.7152 * linearize(g) + 0.0722 * linearize(b);
};

const toHex = n => (n < 16 ? '0' : '') + n.toString(16).toUpperCase();

const darkenHex = (hex, amount) => {
  const normalized = normalizeHexInput(hex);
  if (!normalized) return '';
  const factor = 1 - Math.min(1, Math.max(0, Number(amount) || 0));
  const r = Math.round(parseInt(normalized.slice(1, 3), 16) * factor);
  const g = Math.round(parseInt(normalized.slice(3, 5), 16) * factor);
  const b = Math.round(parseInt(normalized.slice(5, 7), 16) * factor);
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
};

const mixWithWhite = (hex, amount) => {
  const normalized = normalizeHexInput(hex);
  if (!normalized) return '';
  const t = Math.min(1, Math.max(0, Number(amount) || 0));
  const r = parseInt(normalized.slice(1, 3), 16);
  const g = parseInt(normalized.slice(3, 5), 16);
  const b = parseInt(normalized.slice(5, 7), 16);
  return `#${toHex(Math.round(r + (255 - r) * t))}${toHex(Math.round(g + (255 - g) * t))}${toHex(
    Math.round(b + (255 - b) * t)
  )}`;
};

export const getFanCardColors = primaryHex => {
  let fanCardBase = normalizeHexInput(primaryHex) || '#00C8FF';
  let guard = 0;
  while (getRelativeLuminanceFromHex(fanCardBase) > 0.16 && guard < 12) {
    fanCardBase = darkenHex(fanCardBase, 0.12) || fanCardBase;
    guard += 1;
  }
  return {
    from: fanCardBase,
    to: darkenHex(fanCardBase, 0.68) || fanCardBase,
    border: mixWithWhite(darkenHex(fanCardBase, 0.3), 0.08) || fanCardBase,
  };
};
